module.exports = __webpack_public_path__ + "static/media/logo-footer1.2ecd48bf.svg";